'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

const orderFilters = ['All', 'Pending', 'On the Way', 'Delivered', 'Cancelled'];

export default function MyOrderPage() {
  const [activeFilter, setActiveFilter] = useState('All');

  return (
    <div>
      <Navbar />
      <main className="pt-14 md:pt-16 min-h-screen bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 md:px-8 py-8">
          {/* Header */}
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 mb-6">
            <div>
              <h1 className="text-2xl font-extrabold text-gray-900">My Orders</h1>
              <p className="text-sm text-gray-500 mt-1 flex items-center gap-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-gray-400">
                  <circle cx="8" cy="21" r="1" />
                  <circle cx="19" cy="21" r="1" />
                  <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12" />
                </svg>
                Your order history appears here
              </p>
            </div>
            <Link href="/">
              <button className="flex items-center gap-2 px-5 py-2.5 rounded-xl bg-[#0c831f] text-white font-bold text-sm hover:bg-[#065f12] transition-colors active:scale-95">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="8" cy="21" r="1" />
                  <circle cx="19" cy="21" r="1" />
                  <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12" />
                </svg>
                Shop Now
              </button>
            </Link>
          </div>

          {/* Filter Tabs */}
          <div className="flex gap-2 overflow-x-auto pb-2 mb-6 scrollbar-hide">
            {orderFilters?.map((filter) => (
              <button
                key={filter}
                onClick={() => setActiveFilter(filter)}
                className={`px-4 py-2 rounded-xl text-sm font-semibold shrink-0 border transition-all ${
                  activeFilter === filter
                    ? 'bg-[#0c831f] text-white border-[#0c831f]'
                    : 'bg-white text-gray-600 border-gray-200 hover:border-[#0c831f] hover:text-[#0c831f]'
                }`}
              >
                {filter}
              </button>
            ))}
          </div>

          {/* Empty State */}
          <div className="bg-white rounded-2xl border border-gray-200 p-12 flex flex-col items-center justify-center text-center">
            <div className="text-6xl mb-4">🛒</div>
            <h2 className="text-xl font-extrabold text-gray-800 mb-2">No orders yet</h2>
            <p className="text-sm text-gray-500 mb-6">Start shopping and your orders will appear here.</p>
            <Link href="/">
              <button className="flex items-center gap-2 px-6 py-3 rounded-xl bg-[#0c831f] text-white font-bold text-sm hover:bg-[#065f12] transition-colors active:scale-95">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="8" cy="21" r="1" />
                  <circle cx="19" cy="21" r="1" />
                  <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12" />
                </svg>
                Start Shopping
              </button>
            </Link>
            <p className="text-xs text-gray-400 mt-6 flex items-center gap-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="currentColor" className="fill-[#0c831f]">
                <path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z" />
              </svg>
              Groceries delivered in 4 hours
            </p>
          </div>
        </div>
      </main>
      <Footer />
      <style jsx>{`
        .scrollbar-hide::-webkit-scrollbar { display: none; }
        .scrollbar-hide { -ms-overflow-style: none; scrollbar-width: none; }
      `}</style>
    </div>
  );
}
